import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NewEleitorDTO } from '../models/newEleitorDTO.model';
import { EleitorDTO } from '../models/eleitorDTO.model';

@Injectable({
  providedIn: 'root'
})
export class EleitorService {
  configHeader: any;

  constructor(
    private http: HttpClient
    ) { }
  
  public insertEleitor(eleitor: NewEleitorDTO, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post(`${environment.url_api}/eleitor`, eleitor, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, (err) => {
            reject(err);
          }
        )
    })
  }  

  public bulkInsertEleitores(eleitores: NewEleitorDTO[], token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post(`${environment.url_api}/eleitor/bulk`, eleitores, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, (err) => {
            reject(err.error.message);
          }
        )
    })
  }

  public updateEleitor(eleitor: NewEleitorDTO, idEleitor: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token }},
      this.http.put(`${environment.url_api}/eleitor/${idEleitor}`, eleitor, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public updateEleitorEleicaoIniciada(eleitor: NewEleitorDTO, idEleitor: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token }},
      this.http.put(`${environment.url_api}/eleitor/${idEleitor}/eleicaoIniciada`, eleitor, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public excluirEleitorEleicao(idEleitor: any, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.delete(`${environment.url_api}/eleitor/${idEleitor}`, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }
  
}
